import { useMutation, UseQueryResult } from '@tanstack/react-query'
import { queryClient, QueryOptions, UseMutationResult, useResource, useResources } from '.'
import {
  create,
  fetch,
  get,
  JobTitle,
  JobTitleCreationPayload,
  JobTitleUpdatePayload,
  update,
} from '../api/job-titles'

export const jobTitleKeys = {
  create: ['job-titles', 'create'] as const,
  update: ['job-titles', 'update'] as const,
}

//Queries
export const useJobTitleQuery = (
  id?: string,
  options?: QueryOptions<JobTitle>,
): UseQueryResult<JobTitle, any> => useResource<JobTitle>('job-titles', get, id, undefined, options)

export const useJobTitlesQuery = (
  filters?: any,
  options?: QueryOptions<JobTitle[]>,
): UseQueryResult<JobTitle[], any> =>
  useResources<JobTitle[], any>('job-titles', fetch, filters, options)

//Mutations
const onMutationSuccess = () => {
  queryClient.invalidateQueries(['job-titles'])
}

export const useCreateMutation = (): UseMutationResult<JobTitle, JobTitleCreationPayload> =>
  useMutation(create, { mutationKey: jobTitleKeys.create, onSuccess: onMutationSuccess })

export const useUpdateMutation = (): UseMutationResult<JobTitle, JobTitleUpdatePayload> =>
  useMutation(update, {
    mutationKey: jobTitleKeys.update,
    onSuccess: onMutationSuccess,
  })
